
export default function ShowAnyThing(props){
    return(
        <div className="w-screen h-full flex flex-row justify-center">
            <div className="p-3 border-[8px] border-[#1F2937] lg:w-[404px] lg:h-[107px] md:w-[304px] md:h-[87px] w-[210px] h-[68px] flex flex-row justify-center">
                <p className="my-auto lg:text-5xl md:text-3xl text-2xl font-semibold text-[#1F2937]">{props.name}</p>
            </div>
        </div>
    )
}